import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Agent, ENVIRONMENT, Environment, Frontend } from '@netfoundry-ui/shared/model';
import { result, toLower } from 'lodash';
import { catchError, delay } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs/internal/observable/throwError';
import {
    GetOption,
    HateoasResourceOperation,
    HttpMethod,
    PagedGetOption,
    PagedResourceCollection,
} from '@lagoshny/ngx-hateoas-client';
import { take, tap } from 'rxjs/operators';
import { HTTP_CLIENT, TokenService } from './token.service';
import { LoggerService } from './logger.service';


@Injectable({ providedIn: 'root' })
export class FrontendService extends HateoasResourceOperation<Frontend> {
    apiUrl;
    appsUrl;
    networkPricing = 199.0;
    regionPricing = [{ region: null, price: 0.2, rate: 'GB' }];
    lastPageCount = 0;
    lastTotalCount = 0;
    static defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };

    constructor(
        private logger: LoggerService,
        private tokenService: TokenService,
        @Inject(HTTP_CLIENT) private http: HttpClient,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
        super(Frontend);
        this.apiUrl = this.environment.frontdoorURL;

    }


    public findFrontends(options?: PagedGetOption): Promise<Frontend[]> {
        return super
            .getPage({ ...FrontendService.defaultHttpAccept, ...options })
            .pipe(
                tap((val) => {
                    this.lastPageCount = val.totalPages;
                    this.lastTotalCount = val.totalElements;
                })
            )
            .toPromise()
            .then((agents) => (agents ? agents.resources : []));
    }


    public create(model, id) {
        const fullpath = `${this.apiUrl}/${id}/custom-frontends`;
            return this.http
                .post(fullpath, model)
    }

    public delete(frontdoorId, id) {
               const fullpath = `${this.apiUrl}/${frontdoorId}/custom-frontends/${id}`;
            return this.http
                .delete(fullpath) 
    }

    public getDNSRecords(frontdoorId, id) {
        const fullpath = `${this.apiUrl}/${frontdoorId}/custom-frontends/${id}/dns-records`;
            return this.http
                .get(fullpath,{
    headers: { Accept: 'application/hal+json' }})
    }

    public getById(frontdoorId, id) {
        const fullpath = `${this.apiUrl}/${frontdoorId}/custom-frontends/${id}`;
            return this.http
                .get(fullpath,{
    headers: { Accept: 'application/hal+json' }})
    }



    public getFrontends(id) {
        const fullpath = `${this.apiUrl}/${id}/frontends`
        return this.http
            .get(fullpath, {
    headers: { Accept: 'application/hal+json' }})
    }

        public getCustomFrontends(id) {
        const fullpath = `${this.apiUrl}/${id}/custom-frontends`
        return this.http
            .get(fullpath, {
    headers: { Accept: 'application/hal+json' }})
    }



    /**
     * @param path
     * @param data
     */
    public post(path: string, data) {
        const fullpath = `${this.apiUrl}${path}`;
        const body = data;

        return this.http.post(fullpath, JSON.stringify(body), { headers: this.setHeaders() });
    }

    /**
     * @param path
     * @param data
     */
    public put(path: string, data) {
        const fullpath = `${this.apiUrl}${path}`;
        const body = data;

        return this.http.put(fullpath, JSON.stringify(body), { headers: this.setHeaders() });
    }

    /**
     * Generic GETter
     */

    public get(path: string) {
        const fullpath = `${this.apiUrl}${path}`;

        return this.http.get(fullpath, { headers: this.setHeaders() });
    }

    /**
     * Return headers
     */
    private setHeaders(): HttpHeaders {
        const headers = new HttpHeaders();

                  return headers.append('Content-Type', 'application/json');
    }

        /**
     * Generic error handler for bad requests
     */
        protected handleError(scope: any, error: HttpErrorResponse) {
            if (error.error instanceof ErrorEvent) {
                // A client-side or network error occurred. Handle it accordingly.
                scope.logger.error('Feature Service error occurred:', error.error);
            } else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                scope.logger.error(`Feature Backend returned code ${error.status}`, error.error);
            }
            scope.lastErrorSource.next(error);
            return observableThrowError(error);
        }
}
